// Components/Main.js
import React from 'react';
import { 
  Calendar, MapPin, Users, ArrowRight, Sparkles, 
  Clock, Award, Microscope, Building,
} from 'lucide-react';
import CountdownSection from './CountdownSection';
import DepartmentsSection from './Department';
import SimpleVideoSection from './Video';
import Eventhiglishts from './EventHiglishts';
import Gallery from './Gallery';
import Footer from './Footer';
import Schedule from './Schedule';
import iitdimage from '../Assests/iitd_image.webp';
const Main = () => {




  return (
    <main className="min-h-screen bg-gray-50 pt-20">
      {/* Hero Section */}
      <section id="home" className="min-h-screen bg-gradient-to-br from-blue-900 via-purple-900 to-indigo-900 relative overflow-hidden">
        {/* Background Animation */}
        <div className="absolute inset-0">
          <div className="absolute top-20 left-20 w-32 h-32 bg-blue-400 rounded-full opacity-20 animate-pulse"></div>
          <div className="absolute top-60 right-32 w-24 h-24 bg-purple-400 rounded-full opacity-20 animate-bounce"></div>
          <div className="absolute bottom-32 left-32 w-40 h-40 bg-pink-400 rounded-full opacity-15 animate-pulse"></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 py-16">
          {/* Hero Image */}
          <div className="relative mb-16 group">
            <div className="absolute inset-0 bg-gradient-to-r from-purple-600 to-pink-600 rounded-3xl blur-lg opacity-75"></div>
            <div className="relative bg-white rounded-3xl p-4 shadow-2xl">
              <img 
                src={iitdimage}
                alt="IIT Delhi Campus"
                className="w-full h-96 object-fill rounded-2xl"
              />
              
              <div className="absolute top-8 right-8 bg-white/90 backdrop-blur-sm rounded-2xl px-6 py-4 shadow-lg">
                <h2 className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent">
                  Open House 2026
                </h2>
                <div className="flex items-center gap-2 mt-1">
                  <Sparkles className="w-4 h-4 text-yellow-500" />
                  <span className="text-sm text-gray-600 font-medium">October 31, 2026</span>
                </div>
              </div>
            </div>
          </div>

          {/* Hero Content */}
          <div className="text-center text-white">
            <h1 className="text-5xl md:text-7xl font-bold mb-8 leading-tight">
              Welcome to
              <span className="block bg-gradient-to-r from-yellow-400 via-pink-500 to-purple-600 bg-clip-text text-transparent">
                IIT Delhi
              </span>
              <span className="block text-4xl md:text-5xl mt-4">Open House 2026</span>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-300 max-w-4xl mx-auto mb-12 leading-relaxed">
              Explore India's premier institute of technology. Discover groundbreaking research, 
              innovative projects, and the future of engineering and science.
            </p>

            {/* Registration Section */}
            <div className="bg-white/10 backdrop-blur-lg rounded-3xl p-8 md-p-12 border border-white/20 shadow-2xl max-w-4xl mx-auto mb-16">
              <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
                <div className="flex-1 text-left">
                  <div className="flex items-center gap-4 mb-6">
                    <Calendar className="w-12 h-12 text-blue-400" />
                    <div>
                      <h3 className="text-3xl font-bold">Registration</h3>
                      <p className="text-gray-300">October 31, 2026</p>
                    </div>
                  </div>
                  
                  <div className="space-y-4">
                    <div className="flex items-center gap-3">
                      <Clock className="w-5 h-5 text-green-400" />
                      <span className="text-lg">8:00 AM - 9:00 AM</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <MapPin className="w-5 h-5 text-purple-400" />
                      <span className="text-lg">IIT Delhi Campus, Hauz Khas, New Delhi</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <Users className="w-5 h-5 text-pink-400" />
                      <span className="text-lg">Free for All Students & Professionals</span>
                    </div>
                  </div>
                </div>

                <div className="flex-shrink-0">
                  <div className="relative group">
                    <div className="absolute inset-0 bg-gradient-to-r from-green-500 to-blue-600 rounded-full blur opacity-75"></div>
                    
                    <a target='_blank'  rel="noopener noreferrer" href="https://iitd-openhouse2025.web.app/" className="relative bg-gradient-to-r from-green-500 to-blue-600 text-white font-bold py-6 px-12 rounded-full text-2xl shadow-lg hover:scale-110 transition-all duration-300 flex items-center gap-3">
                      <span>Register Now</span>
                      <ArrowRight className="w-6 h-6" />
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Countdown Timer Section */}
            <CountdownSection />
            {/* end Countdown Timer Section */}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-5xl font-bold text-gray-800 mb-6">About IIT Delhi</h2>
            <p className="text-xl text-gray-600 max-w-4xl mx-auto">
              Established in 1961, IIT Delhi is one of India's premier institutions for engineering, 
              technology, and research. Join us to explore our world-class facilities and innovations.
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8 hover:shadow-xl transition-shadow">
              <Award className="w-16 h-16 text-blue-600 mb-6" />
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Excellence in Education</h3>
              <p className="text-gray-600">Top-ranked programs with world-class faculty and cutting-edge curriculum.</p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-8 hover:shadow-xl transition-shadow">
              <Microscope className="w-16 h-16 text-purple-600 mb-6" />
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Research Innovation</h3>
              <p className="text-gray-600">Groundbreaking research across multiple disciplines with global impact.</p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-8 hover:shadow-xl transition-shadow">
              <Building className="w-16 h-16 text-green-600 mb-6" />
              <h3 className="text-2xl font-bold text-gray-800 mb-4">World-Class Campus</h3>
              <p className="text-gray-600">State-of-the-art facilities spread across 325 acres in the heart of Delhi.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section - Added id="video" here */}
      <section id="video">
        <SimpleVideoSection />
      </section>
      
      {/* Departments Section */}
      <DepartmentsSection />
      
      {/* Gallery Section - Added here */}
      <Gallery />

      {/* Schedule Section */}
      <section id="schedule" className="py-20 bg-gray-50">
    <Schedule />
      </section>


      {/* Event Highlights Section */}
      <Eventhiglishts />
      
      {/* Footer Section with id="contact" */}
     <section id="contact" className="bg-gray-800">
  <Footer />
</section>
    </main>
  );
};

export default Main;